import React, { useReducer } from "react";
import { LanguageContext } from "./LanguageContext";
import { LanguageReducer } from "./LanguageReducer";
import { EDIT_LANG } from "../types";

export const LanguageState = ({children}) => {
    const [state, dispatch] = useReducer(LanguageReducer, {lang: "ru"});

    const editLang = lang => {
        dispatch({type: EDIT_LANG, lang});
    }

    return (
        <LanguageContext.Provider value={{
            lang: state.lang, editLang
        }}>{children}</LanguageContext.Provider>
    );
}